var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},_vm._l((_vm.children),function(child){return _c('PluginsSetting',_vm._b({key:child.label},'PluginsSetting',child.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }